"use strict";
import { Message } from "@alifd/next";
import { isMatchBusinessCode } from "./common";
export function handleError(err) {
  const isShowErrFlag = isMatchBusinessCode(err.BusinessCode);
  if (err && !isShowErrFlag) {
    Message.error({ title: err.Message, duration: 3e3 });
  }
}
